import React, { createContext, useState, useContext } from 'react';

// Create a context with default value as false
const BusyContext = createContext(false);

export const BusyProvider = ({ children }) => {
    const [isBusy, setIsBusy] = useState(false);

    const setBusy = (busy) => {
        setIsBusy(busy);
    };

    return (
        <BusyContext.Provider value={{ isBusy, setBusy }}>
            {children}
        </BusyContext.Provider>
    );
};

export const useBusy = () => {
    return useContext(BusyContext);
};